export default{
    drOrClinic : 'Dr Or Clinic',
    fertilityDate  : 'Fertility Date',
    ivf  : 'IVF',
    iui  : 'IUI',
    io  : 'IO',
    pgd  : 'PGD',
    pgdDescription  : 'Pgd Description',
    pgs  : 'PGS',
    pgsDescription  : 'pgs Description',
    eggsCount:'Eggs Count',
    numberOfFetuses:'Fetuses Count',
    gradeOfEmbryo:'gradeOfEmbryo',
    typeOfTransferOperation:'Transfer Operation Type',
    description:'Description',
    resultTransferOperationType:'Transfer Operation Result',
}